<template>
	<div class="celloger_pro">
		<PageBanner></PageBanner>
		<div id="title" class="pro_title">
			<span class="pro_eng_title">Celloger Pro</span> 全自动活细胞成像分析系统
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="pro_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">全自动活细胞成像分析系统</p>
			<p class="p2">Celloger Pro</p>
			<p class="p3">Celloger® Pro是一款创新型活细胞成像系统，重新定义了科研能力。<br>
				凭借出众的图像质量和便利性，Celloger® Pro给科研人员提供了更加先<br>
				进的功能。通过在培养箱内实时监测细胞，可以实现在不破坏细胞自然<br>
				生长环境的情况下无缝观察和追踪细胞动态。双荧光和明场显微镜可以<br>
				同时可视化多个标记，多点延时成像可以捕获不同位点的细胞动态变化。</p>
			<img src="../assets/img/production/Celloger Pro_2.png" class="pro_img" />
		</div>
		<p class="exp3">Celloger® Pro是一款创新型活细胞成像系统，重新定义了科研能力。
			凭借出众的图像质量和便利性，Celloger® Pro给科研人员提供了更加先
			进的功能。通过在培养箱内实时监测细胞，可以实现在不破坏细胞自然
			生长环境的情况下无缝观察和追踪细胞动态。双荧光和明场显微镜可以
			同时可视化多个标记，多点延时成像可以捕获不同位点的细胞动态变化。</p>
		<img src="../assets/img/production/产品中心 条幅1.jpg" style="width: 100%;margin-top: 10vh;" />

		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 25px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" style="font-size: 30px;font-weight: bold;margin-top: 3vh;">培养箱内实时监测细胞状态</p>
		<ul id="title" class="subtext" style="line-height: 40px;">
			<li>Celloger Pro设计用于在培养箱内细胞的实时观察，仅需将设备<br class="br">
				放置在培养箱内并连接到外部的电脑，研究人员即可远程实时观<br class="br">
				察细胞了。</li>
			<li style="margin-top: 20px;">通过延时功能，研究人员可以通过设置的时间表来捕获细胞图<br class="br">
				像，所获的图像可以轻松转化成视频。</li>
		</ul>
		<div class="img_container32">
			<img src="../assets/img/production/32.png" class="img_32" />
		</div>
		<p id="title" class="maintext" style="margin-top: 20vh;">可更换的物镜</p>
		<p id="title" class="subtext" style="text-indent: 2em;">Celloger Pro为用户提供可更换的物镜，灵活满足研究人员的不同需求。有2X，4X和10X的物镜供选择，用户可以自由切换。</p>
		<div class="img_container33">
			<img src="../assets/img/production/33.png" class="img_33" />
		</div>
		<p id="title" class="maintext">双色荧光和明场镜头</p>
		<ul id="title" class="subtext">
			<li>凭借双色荧光和明场镜头，Celloger Pro可以拍摄高质量和高分辨率图片。</li>
			<li style="margin-top: 20px;">借助增强的扫描方法和创新的融合图像技术，设备减少了扫描时间，让研究人员能够以突出的清晰度和效率分析细胞运动。</li>
		</ul>
		<div class="img_container34">
			<img src="../assets/img/production/34.png" class="img_34" />
		</div>
		<p id="title" class="maintext">多孔位延时成像功能</p>
		<p id="title" class="subtext" style="line-height: 2rem;text-indent: 2em;">Celloger
			Pro通过自动移动的集成相机和固定在平台的培养耗材和样本，在多个位点进行细胞成像。这样确保了细胞的稳定环境，
			从而提高了图像质量和研究准确性。</p>
		<div class="img_container35">
			<img src="../assets/img/production/35.png" class="img_35" />
		</div>
		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'CellogerPro',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".pro_container, .img_container32, .img_container33, .img_container34, .img_container35"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 10vh;
	}

	.subtext {
		font-size: 18px;
	}

	.pro_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 450px;
		width: 1200px;
	}

	.pro_img {
		position: absolute;
		width: auto;
		height: 350px;
		margin-left: 660px;
	}

	.pro_container p {
		position: absolute;
	}

	.pro_container .p1 {
		margin-right: 640px;
		margin-bottom: 250px;
		font-size: 28px;
	}

	.pro_container .p2 {
		margin-right: 670px;
		margin-bottom: 170px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.pro_container .p3 {
		margin-right: 400px;
		margin-top: 150px;
		font-size: 18px;
		line-height: 2;
	}

	.img_32 {
		width: 600px;
		height: 470px;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 30vh;
	}

	.img_33 {
		width: 940px;
		height: 646px;
		margin-top: 5vh;
	}

	.img_34 {
		width: 1000px;
		height: 900px;
		margin-top: 5vh;
	}

	.img_35 {
		width: 957px;
		height: 534px;
		margin-top: 5vh;
	}

	.img_container32, .img_container33, .img_container34, .img_container35 {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.pro_title {
		font-size: 1.8em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.pro_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 20px;
		margin-bottom: 5vh;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.exp3 {
		display: none;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.pro_container .p1 {
			margin-right: 530px;
			margin-top: 50px;
			font-size: 1.5rem;
		}

		.pro_container .p2 {
			margin-right: 620px;
			margin-top: 50px;
			font-size: 2rem;
		}

		.pro_container .p3 {
			margin-right: 300px;
			font-size: 1rem;
			margin-top: 120px;
		}

		.pro_img {
			position: absolute;
			width: auto;
			height: 250px;
			margin-left: 620px;
		}

		.img_32 {
			width: 460px;
			height: 380px;
		}

		.img_33 {
			width: 840px;
			height: 546px;
			margin-top: 5vh;
		}

		.img_34 {
			width: 800px;
			height: 720px;
			margin-top: 5vh;
		}

		.img_35 {
			width: 827px;
			height: 454px;
			margin-top: 5vh;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.pro_title {
			font-size: 1rem;
			margin-top: 5vh;
		}

		.pro_eng_title {
			font-size: 1rem;
			margin-bottom: 5.2rem;
			letter-spacing: 1px;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.pro_container .p1 {
			font-size: 1.1rem;
			margin-right: 160px;
			margin-top: 220px;
		}

		.pro_container .p2 {
			font-size: 1.1rem;
			margin-right: 200px;
			margin-top: 220px;
		}

		.pro_container .p3 {
			display: none;
		}

		.pro_img {
			height: 140px;
			width: auto;
			margin-top: 40px;
			margin-left: 220px;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.banner3 {
			margin-top: 2vh;
			width: 100%;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_32 {
			width: 420px;
			height: auto;
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.img_33, .img_34, .img_35 {
			width: 380px;
			height: auto;
			margin-top: 5vh;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		.br {
			display: none;
		}
	}
</style>